import { DeliveryMethod } from "../constants";

const shouldAutoPrintLabel = (defaultLocale: string | undefined | null,
                              deliveryMethod: string | null | undefined,
                              labelPrint: string | null | undefined): boolean => {
  const isLithuanian = (defaultLocale === "lt" || defaultLocale === 'lv');
  const noLabelYet = labelPrint == null;
  const doorToPudo = deliveryMethod === DeliveryMethod.DoorToPudo;

  return isLithuanian && (noLabelYet || doorToPudo);
}

export default shouldAutoPrintLabel;